import React, {useEffect, useState} from 'react';

import { InputField, CheckBoxesField } from 'basics';

import { mergeRoles } from 'model/options';

export default function TopicForm({register, errors, item})
{
	const [awardRoles, setAwardRoles] = useState([]);

	useEffect(()=>{

		setAwardRoles(mergeRoles(item && item.roles));

	}, [item]);

	return (
		<>
			<InputField
				label="Título"
				type="text"
				value={item && item.title}
				id="title"
				register={register}
				errors={errors}
				mode="dark"
			/>
			<InputField
				label="Descripción"
				type="text"
				value={item && item.description}
				id="description"
				register={register}
				errors={errors}
				mode="dark"
			/>
			<CheckBoxesField
				options={awardRoles}
				register={register}
				error={errors.roles}
				id="roles"
				label="Roles Asociados"
				mode="dark"
				twoLines={true}
			/>
		</>
	)
}